import React from 'react';
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import {CaseForms} from "../../../../helpers/enums";

import './VerificaContatoreCase.scss';
import useSimpleCaseData from "../../../../hooks/useSimpleCaseData";

const VerificaContatoreCase = () => {
  const {data, blockCaseIfNoContract} = useSimpleCaseData();
  return (
    <div className="VerificaContatoreCase" data-testid="VerificaContatoreCase">
      <CaseGenerator
        type={CaseForms.VerificaContatore}
        initialValues={data}
        blockIfNoContracts={blockCaseIfNoContract}
      />
    </div>
  );
};
export default VerificaContatoreCase;
